<div class="min-h-screen flex items-center justify-center bg-gray-50">
  <div class="text-center px-4">
    <h1 class="text-5xl font-bold text-green-800 mb-4">{{title$ | async }}</h1>
    <p class="text-xl text-gray-600 mb-8">{{ subtitle$ | async }}</p>
    
    <!-- Uncomment this section when ready to add email subscription -->
    <!-- <div class="max-w-md mx-auto">
      <div class="flex gap-2">
        <input type="email" placeholder="Enter your email" class="flex-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-800">
        <button class="px-6 py-2 bg-green-800 text-white rounded-lg hover:bg-green-700 transition-colors">
          Notify Me
        </button>
      </div>
    </div> -->

    <div class="max-w-md mx-auto">

      <form class="flex gap-2" [formGroup]="subscribeForm" (ngSubmit)="onSubmit()">
        <input 
          name="email"
          type="email" 
          placeholder="Your email address" 
          autocomplete="email"
          class="flex-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-800"
          formControlName="email"
          [class.border-red-500]="subscribeForm.get('email')?.invalid && subscribeForm.get('email')?.touched"
          required>
        <button 
          type="submit" 
          class="px-6 py-2 bg-green-800 text-white rounded-lg hover:bg-green-700 transition-colors"
          [disabled]="subscribeForm.invalid || isSubmitting">
          {{isSubmitting ? 'Subscribing...' : 'Notify Me'}}
        </button>
      </form>
    </div>

    <div class="mt-8 max-w-xl -text-left text-xl text-gray-600 mb-8">
      <!-- <h1 class="p-2">Are you ready for The First Steep?</h1>
      <p class="p-2">
        New Releases, Pre-Orders and Discounts.
      </p> -->
      <!-- <p class="p-2">
        Dive into a world of exquisite flavours and exclusive launches with The First Steep Chronicle. Be the first to savour our newest premium blends and secure pre-orders ahead of the crowd. Our carefully curated selections are crafted with the finest leaves, designed to enrich your tea experience. Sign up now to receive insider access to unique releases and a taste of luxury that awaits your cup!
      </p> -->
    </div>

<!--    -->
  </div>
</div>
